(function () {
  'use strict';

  var menuButton = document.querySelector('.menu-toggle');
  var nav = document.querySelector('#SiteNav');

  if (menuButton && nav) {
    menuButton.addEventListener('click', function () {
      var isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        menuButton.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
        menuButton.focus();
      }
    });
  }

  document.querySelectorAll('input[type="number"]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (Number(input.value) < 1 || !input.value) input.value = 1;
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    var price = form && form.closest('.product-info').querySelector('[data-product-price]');
    var addButton = form && form.querySelector('[data-add-button]');
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      var layout = select.closest('.product-layout');
      if (layout) {
        layout.querySelectorAll('[data-media-finish]').forEach(function (item) {
          var isSelected = item.dataset.mediaId === option.dataset.mediaId;
          item.hidden = !isSelected && Boolean(item.dataset.mediaFinish && item.dataset.mediaFinish !== option.dataset.finish);
          item.classList.toggle('is-selected-media', isSelected);
        });
      }
      if (layout) layout.dispatchEvent(new CustomEvent('product:variant-change'));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      if (addButton) {
        addButton.disabled = option.disabled;
        addButton.textContent = option.disabled ? 'Sold out' : 'Add to cart';
      }
    });
  });

  document.querySelectorAll('.product-layout').forEach(function (layout) {
    var gallery = layout.querySelector('.product-gallery');
    var controls = layout.querySelector('[data-gallery-controls]');
    var select = layout.querySelector('[data-variant-select]');
    var sticky = layout.querySelector('[data-sticky-buy]');
    var add = layout.querySelector('[data-add-button]');
    var mobile = window.matchMedia('(max-width: 800px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var visibleItems = function () {
      return Array.from(gallery.querySelectorAll('.product-gallery__item:not([hidden])')).sort(function (a, b) {
        return Number(b.classList.contains('is-selected-media')) - Number(a.classList.contains('is-selected-media'));
      });
    };
    var currentIndex = function (items) {
      var left = gallery.getBoundingClientRect().left;
      var best = 0;
      items.forEach(function (item, index) {
        if (Math.abs(item.getBoundingClientRect().left - left) < Math.abs(items[best].getBoundingClientRect().left - left)) best = index;
      });
      return best;
    };
    var updateGallery = function () {
      if (!gallery || !controls) return;
      var items = visibleItems();
      var index = currentIndex(items);
      controls.hidden = items.length < 2;
      controls.querySelector('[data-gallery-status]').textContent = (index + 1) + ' / ' + items.length;
      controls.querySelector('[data-gallery-previous]').disabled = index === 0;
      controls.querySelector('[data-gallery-next]').disabled = index >= items.length - 1;
    };
    if (gallery && controls) {
      controls.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          var items = visibleItems();
          var direction = button.hasAttribute('data-gallery-next') ? 1 : -1;
          var item = items[currentIndex(items) + direction];
          if (item) gallery.scrollTo({left: gallery.scrollLeft + item.getBoundingClientRect().left - gallery.getBoundingClientRect().left, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
        });
      });
      gallery.addEventListener('scroll', updateGallery, {passive: true});
      updateGallery();
    }
    var updateStickyVisibility = function () {
      if (sticky && add) sticky.hidden = !mobile.matches || add.getBoundingClientRect().bottom >= 0;
    };
    if (sticky && add && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(updateStickyVisibility);
      observer.observe(add);
      window.addEventListener('resize', updateStickyVisibility, {passive: true});
      var visibilityFrame = 0;
      window.addEventListener('scroll', function () {
        if (visibilityFrame) return;
        visibilityFrame = window.requestAnimationFrame(function () {
          visibilityFrame = 0;
          updateStickyVisibility();
        });
      }, {passive: true});
    }
    layout.addEventListener('product:variant-change', function () {
      if (gallery) gallery.scrollTo({left: 0, behavior: 'instant'});
      updateGallery();
      if (!select) return;
      var option = select.options[select.selectedIndex];
      var note = layout.querySelector('[data-reference-note]');
      if (note) note.hidden = option.dataset.referenceImage !== 'true';
      if (sticky) {
        sticky.querySelector('[data-sticky-price]').textContent = option.dataset.price;
        sticky.querySelector('[data-sticky-finish]').textContent = option.dataset.finish;
        var button = sticky.querySelector('[data-sticky-add]');
        button.disabled = option.disabled;
        button.textContent = option.disabled ? button.dataset.labelUnavailable : button.dataset.labelAvailable;
      }
    });
  });
})();